import { KeyValuePair } from "./KeyValuePair";

export enum IntendedUseEnum {
  internalUse = 0,
  opportunity,
  partnerOpportunity,
  webinar,
  learning,
  test
}

export const boardIntendedUses: KeyValuePair<number>[] = [
  {
    id: IntendedUseEnum.opportunity,
    name: "Opportunity"
  },
  {
    id: IntendedUseEnum.webinar,
    name: "Webinar / Event"
  },
  {
    id: IntendedUseEnum.learning,
    name: "Learning / Training"
  },
  {
    id: IntendedUseEnum.test,
    name: "Test"
  }
];

export const partnerIntendedUses: KeyValuePair<number>[] = [
  {
    id: IntendedUseEnum.partnerOpportunity,
    name: "Partner Opportunity"
  },
  {
    id: IntendedUseEnum.webinar,
    name: "Webinar / Event"
  },
  {
    id: IntendedUseEnum.learning,
    name: "Learning / Training"
  },
  {
    id: IntendedUseEnum.test,
    name: "Test"
  }
];

const allIntendedUses: KeyValuePair<number>[] = [
  ...boardIntendedUses,
  ...partnerIntendedUses,
  { id: IntendedUseEnum.internalUse, name: "Internal Use" }
];

export function getIntendedUseDescription(intendedUse?: IntendedUseEnum): string {
  const use = allIntendedUses.find(x => x.id === intendedUse);
  return use ? use.name : "";
}
